import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import api from "../utils/api.js";

export default {
  state: {
    backups: {},
    schedules: {}
  },
  mutations: {
    SET_BACKUPS: (state, payload, rootState) => {
      state.backups = payload;
    },
    SET_SCHEDULES: (state, payload, rootState) => {
      state.schedules = payload;
    }
  },
  actions: {
    getSchedules(context) {
      let params = {
        requiredData: {
          scheduleBackupGetBackupsV3: 1
        }
      };
      return api
        .post(params)
        .then(response => {
          context.commit(
            "SET_SCHEDULES",
            response.data.scheduleBackupGetBackupsV3
          );
        })
        .catch(error => context.commit("API_FAILURE", error));
    }
  },
  getters: {
    getBackups: (state, getters) => {
      return state.backups;
    },
    getSchedules: (state, getters) => {
      return state.schedules;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/backups/index.js